import { createSlice } from "@reduxjs/toolkit";

export const organizationBillingUsageSlice = createSlice({
  name: "organizationBillingUsageSlice",
  initialState: {
    orgCode: null,

    isCreatingOrgBillingUsage: false,
    createOrgBillingUsageMessage: null,
    createOrgBillingUsageError: null,

    billingUsage: null,
    isGettingOrgBillingUsage: false,
    getOrgBillingUsageMessage: null,
    getOrgBillingUsageError: null
  },
  reducers: {
    createOrgBillingUsage: (state, action) => {
      state.isCreatingOrgBillingUsage = true;
      state.createOrgBillingUsageMessage = null;
      state.createOrgBillingUsageError = null;
    },
    createOrgBillingUsageSuccessful: (state, action) => {
      state.isCreatingOrgBillingUsage = false;
      state.createOrgBillingUsageMessage = action.payload;
      state.createOrgBillingUsageError = null;
    },
    createOrgBillingUsageFailure: (state, action) => {
      state.isCreatingOrgBillingUsage = false;
      state.createOrgBillingUsageMessage = null;
      state.createOrgBillingUsageError = action.payload.message;
    },
    getOrgBillingUsage: (state, action) => {
      state.billingUsage = null;
      state.isGettingOrgBillingUsage = true;
      state.getOrgBillingUsageMessage = null;
      state.getOrgBillingUsageError = null;
    },
    getOrgBillingUsageSuccessful: (state, action) => {
      state.isGettingOrgBillingUsage = false;
      state.billingUsage = action.payload;
      state.getOrgBillingUsageMessage = "Billing usage retrieved successfully";
      state.getOrgBillingUsageError = null;
    },
    getOrgBillingUsageFailure: (state, action) => {
      state.isGettingOrgBillingUsage = false;
      state.billingUsage = action.payload;
      state.getOrgBillingUsageMessage = null;
      state.getOrgBillingUsageError = action.payload.message;
    },
    clearAllOrgBillingUsageMessages : (state) => {},
    clearAllOrgBillingUsageMessagesSuccessful : (state) => {
      state.createOrgBillingUsageMessage= null;
      state.createOrgBillingUsageError= null;
      state.getOrgBillingUsageMessage = null;
      state.getOrgBillingUsageError = null;
    }
  }
});

export const {
  createOrgBillingUsage,
  createOrgBillingUsageSuccessful,
  createOrgBillingUsageFailure,
  getOrgBillingUsage,
  getOrgBillingUsageSuccessful,
  getOrgBillingUsageFailure,
  clearAllOrgBillingUsageMessages,
  clearAllOrgBillingUsageMessagesSuccessful
} = organizationBillingUsageSlice.actions;

export default organizationBillingUsageSlice.reducer;